import {React} from 'common'
import Menu from '@mui/material/Menu'
import MobileMenuItem from './MobileMenuItem'
import {Styles} from 'appearance'
import UseMainMenu from 'logic/Menu/UseMainMenu'

const MobileMenu = ({
    mobileMenuId,
    setAnchorEl,
    mobileMoreAnchorEl,
    setMobileMoreAnchorEl,
}) => {
    const {
        isMobileMenuOpen,
        handleProfile,
        handleMobileMenuClose,
        doLogout,
        t,
    } = UseMainMenu({
        mobileMoreAnchorEl,
        setAnchorEl,
        setMobileMoreAnchorEl,
    })

    return (
        <Menu
            keepMounted
            id={mobileMenuId}
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={Styles.MENU_ANCHOR_ORIGIN}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}>
            <MobileMenuItem
                onClick={handleProfile}
                type="myAccount"
                text={t('myAccount')}
            />
            <MobileMenuItem
                onClick={doLogout}
                type="logout"
                text={t('logout')}
            />
        </Menu>
    )
}

export default MobileMenu
